import {
  DashboardOutlined,
  AppstoreOutlined,
  TableOutlined,
  HistoryOutlined,
  SettingOutlined,
  CreditCardOutlined,
  BarChartOutlined,
  UserOutlined,
  ShopOutlined,
  TagsOutlined,
  DropboxOutlined,
  TeamOutlined,
  SafetyCertificateOutlined,ControlOutlined,FileDoneOutlined,
  ApartmentOutlined,
} from '@ant-design/icons';
import { InboxOutlined } from "@ant-design/icons";

export const MenuList = [
  {
    key: 'manage-restaurants',
    module_key: 'manage_restaurants',
    icon: <ShopOutlined />,
    label: <span className="menu-label">Manage Restaurants</span>,
    to: '/manage-restaurants',
  },

  {
    key: 'dashboard',
    module_key: 'dashboard',
    icon: <DashboardOutlined />,
    label: <span className="menu-label">Dashboard</span>,
    to: '/dashboard',
  },

  {
    key: 'billing',
    icon: <TableOutlined />,
    label: <span className="menu-label">Billing</span>,
    children: [
      {
        key: 'tables-bills',
        module_key: 'manage_bills',
        icon: <AppstoreOutlined />,
        label: <span className="submenu-label">Tables & Bills</span>,
        to: '/manage-bills',
      },
      {
        key: 'bill-history',
        module_key: 'bill_history',
        icon: <HistoryOutlined />,
        label: <span className="submenu-label">Bill History</span>,
        to: '/bill-history',
      },
    ],
  },

  {
    key: 'menu-management',
    icon: <ShopOutlined />,
    label: <span className="menu-label">Menu Management</span>,
    children: [
      {
        key: 'manage-menu',
        module_key: 'manage_menu',
        icon: <AppstoreOutlined />,
        label: <span className="submenu-label">Manage Menu</span>,
        to: '/manage-menu',
      },
      {
        key: 'food-category',
        module_key: 'food_category',
        icon: <TagsOutlined />,
        label: <span className="submenu-label">Food Categories</span>,
        to: '/food-category',
      },
      // Drink Category and Manage Drink are disabled for now:
      // {
      //   key: 'drink-category',
      //   module_key: 'drink_category',
      //   icon: <TagsOutlined />,
      //   label: <span className="submenu-label">Drinks Categories</span>,
      //   to: '/drinks-category',
      // },
      // {
      //   key: 'manage-drink',
      //   module_key: 'manage_drink',
      //   icon: <AppstoreOutlined />,
      //   label: <span className="submenu-label">Manage Drinks</span>,
      //   to: '/manage-drink',
      // },
    ],
  },

  {
    key: 'room-service',
    module_key: 'room_service',
    icon: <ApartmentOutlined />,
    label: <span className="menu-label">Room Service</span>,
    to: '/room-service',
  },

  {
    key: 'operations',
    icon: <SettingOutlined />,
    label: <span className="menu-label">Operations</span>,
    children: [
      {
        key: 'zone-management',
        module_key: 'zone',
        icon: <SettingOutlined />,
        label: <span className="submenu-label">Zone Management</span>,
        to: '/zone',
      },
      {
        key: 'table-management',
        module_key: 'manage_table',
        icon: <TableOutlined />,
        label: <span className="submenu-label">Table Management</span>,
        to: '/manage-table',
      },

    {
      key: 'vendor',
      module_key: 'vendor',
      icon: <InboxOutlined />,
      label: <span className="submenu-label">Vendor</span>,
      to: '/vendor',
    },
    {
      key: 'In-House-Expenses',
      module_key: 'in_house_expenses',
      icon: <InboxOutlined />,
      label: <span className="submenu-label"> In House Expenses</span>,
      to: '/In-House-Expenses',
    },

    {
      key: 'Manage-Expense',
      module_key: 'manage_expense',
      icon: <InboxOutlined />,
      label: <span className="submenu-label">Expense Categories</span>,
      to: '/manage-expense',
    },
     {
      key: 'food-stock-spent',
      module_key: 'food_stock_spent',
      icon: <InboxOutlined />,
      label: <span className="submenu-label"> Stock Consumption</span>,
      to: '/food-stock-spent',
    },
    {
      key: 'pdf-config',
      module_key: 'pdf_config',
      icon: <InboxOutlined />,
      label: <span className="submenu-label">PDF Configuration</span>,
      to: '/pdf-config',
    },
    ],
  },

  // {
  //   key: 'payments',
  //   module_key: 'manage_payments',
  //   icon: <CreditCardOutlined />,
  //   label: <span className="menu-label">Payments</span>,
  //   to: '/manage-payments',
  // },

  // {
  //   key: 'purchases',
  //   icon: <DropboxOutlined />,
  //   label: <span className="menu-label">Purchases</span>,
  //   children: [
  //     {
  //       key: 'vendors',
  //       module_key: 'manage_vendor',
  //       icon: <UserOutlined />,
  //       label: <span className="submenu-label">Vendors</span>,
  //       to: '/manage-vendor',
  //     },
  //     {
  //       key: 'purchase-orders',
  //       module_key: 'purchase_order',
  //       icon: <DropboxOutlined />,
  //       label: <span className="submenu-label">Purchase Orders</span>,
  //       to: '/purchase-order',
  //     },
  //   ],
  // },

  {
    key: 'reports',
    icon: <BarChartOutlined />,
    label: <span className="menu-label">Reports</span>,
    children: [
      {
        key: 'table-report',
        module_key: 'table_report',
        icon: <TableOutlined />,
        label: <span className="submenu-label">Table Report</span>,
        to: '/report/tables',
      },
      {
        key: 'bill-report',
        module_key: 'bill_report',
        icon: <HistoryOutlined />,
        label: <span className="submenu-label">Bill Report</span>,
        to: '/report/bills',
      },
              {
          key: 'parcel-item-report',
          module_key: 'parcel_item_report',
          icon: <FileDoneOutlined />,
          label: <span className="submenu-label">Parcel Item Report</span>,
          to: '/report/parcel-items',
        },
        {
              key: 'food-stock-report',
              module_key: 'food_stock_report',
              icon: <InboxOutlined />,
              label: <span className="submenu-label">Stock Report</span>,
              to: '/report/foodstock',
            },
      

       
    {
      key: 'sales-report',
      module_key: 'sales_report',
      icon: <InboxOutlined />,
      label: <span className="submenu-label">Sales Report</span>,
      to: '/report/sales',
    },
    ],
  },

  {
    key: 'user-management',
    icon: <TeamOutlined />,
    label: <span className="menu-label">User Management</span>,
    children: [
      {
        key: 'manage-user',
        module_key: 'manage_user',
        icon: <UserOutlined />,
        label: <span className="submenu-label">Manage User</span>,
        to: '/manage-user',
      },
      {
        key: 'user-permission',
        module_key: 'user_permission',
        icon: <SafetyCertificateOutlined />,
        label: <span className="submenu-label">User Permission</span>,
        to: '/user-permission',
      },
    ],
  },
    {
    key: 'general-settings', // unique key
    module_key: 'general_settings',
    icon: <ControlOutlined />,
    label: <span className="menu-label">General Settings</span>,
    to: '/general-settings',
  },


  {
    key: 'profile',
    module_key: 'profile',
    icon: <UserOutlined />,
    label: <span className="menu-label">Profile</span>,
    to: '/profile',
  },
];
